import { CoreModule } from 'dynamsoft-core'
import { LicenseManager } from 'dynamsoft-license'
import 'dynamsoft-barcode-reader'

// Set up engine resource paths
CoreModule.engineResourcePaths.rootDirectory = 'https://cdn.jsdelivr.net/npm/'

const isActualMobileDevice = () => {
  const userAgent = navigator.userAgent.toLowerCase()

  // Check if it's running in a desktop browser
  const isDesktop = /windows|mac|linux/i.test(userAgent) &&
    !/android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent)

  // If it's a desktop browser, return false regardless of viewport/emulation
  if (isDesktop) {
    return false
  }

  // Additional checks for actual mobile hardware
  const hasTouchScreen = navigator.maxTouchPoints > 0 ||
    'ontouchstart' in window ||
    // @ts-ignore
    (navigator.msMaxTouchPoints > 0)

  // Check for mobile-specific navigator properties
  const isMobileUA = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent)

  // Check for mobile-specific platform
  const isMobilePlatform = /android|iphone|ipad|ipod/i.test(navigator.platform)

  // Must satisfy all conditions to be considered a real mobile device
  return isMobileUA && isMobilePlatform && hasTouchScreen
}

// Initialize Dynamsoft license with proper error handling
const initializeDynamsoftLicense = async () => {
  try {
    // Only initialize for actual mobile devices
    if (isActualMobileDevice()) {
      console.log('Initializing Dynamsoft license for actual mobile device...')

      // Optional: Set a friendly device name (must be called before license initialization)
      LicenseManager.setDeviceFriendlyName('MyMobileApp-Device')

      // Initialize license with executeNow: true for immediate execution and error handling
      await LicenseManager.initLicense(
        'DLS2eyJoYW5kc2hha2VDb2RlIjoiMTAzNDYzMTM5LTEwMzUxMTAxMCIsIm1haW5TZXJ2ZXJVUkwiOiJodHRwczovL21kbHMuZHluYW1zb2Z0b25saW5lLmNvbS8iLCJvcmdhbml6YXRpb25JRCI6IjEwMzQ2MzEzOSIsInN0YW5kYnlTZXJ2ZXJVUkwiOiJodHRwczovL3NkbHMuZHluYW1zb2Z0b25saW5lLmNvbS8iLCJjaGVja0NvZGUiOjIwNTM3OTU2MzZ9',
        { executeNow: true }
      )

      console.log('Dynamsoft license initialized successfully')

      // Get device UUID for logging/debugging purposes
      const deviceUUID = await LicenseManager.getDeviceUUID()
      console.log('Device UUID:', deviceUUID)

    } else {
      console.log('Dynamsoft license initialization skipped - not an actual mobile device')
    }
  } catch (error) {
    console.error('Dynamsoft license initialization failed:', error)

    // Handle specific license errors
    if (error.message) {
      console.error('License error message:', error.message)
    }

    // You might want to show user-friendly error messages or fallback behavior here
    throw error // Re-throw if you want calling code to handle it
  }
}

// Initialize license and then preload WASM modules
const initializeDynamsoft = async () => {
  try {
    // Step 1: Initialize license first
    await initializeDynamsoftLicense()

    // Step 2: Preload BarcodeReader WASM module after license initialization
    console.log('Loading Dynamsoft WASM modules...')
    await CoreModule.loadWasm(['DBR'])
    console.log('Dynamsoft WASM modules loaded successfully')

  } catch (error) {
    console.error('Dynamsoft initialization failed:', error)
    // Handle initialization failure appropriately for your app
  }
}

// Execute initialization
initializeDynamsoft()

// Export the initialization function if you need to call it from other modules
export { initializeDynamsoft, isActualMobileDevice }
